/**
 * @fileoverview Music theme - match musical instrument emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Music theme with instruments and musical notes.
 */
export class MusicTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'music',
            'Music',
            allLabels.music,
            { numPairs: 3, isPremium: false, hasMovement: false, ...options }
        );
    }
}
